export const ActionType = {
  OPEND_DRAW_INSTRUMENT: "OPEND_DRAW_INSTRUMENT"
};
